﻿(function () {

    'use strict';
    var controllerId = 'dashboardController';

    angular
        .module('app.controllers')
        .controller(controllerId, dashboardController);

    dashboardController.$inject = ['$scope', '$location', 'common', 'datacontext', 'ngDialog', '$rootScope', '$state', 'config'];

    function dashboardController($scope, $location, common, datacontext, ngDialog, $rootScope, $state, config) {

        var vm = this;
        vm.create = new Date();
        vm.SearchContract = searchContract;
        vm.selectedModel = {};


        init();
        
        function init()
        {       
        }

        function searchContract() {
            common.logger.debug('check with toolbar');
        }
      
        $scope.remoteUrlRequestFn = function (str) {
            return datacontext.security.getLanguagesByCulture("ES-ES");
        };

    }

})();
